import { useEffect } from 'react'
import { useAuth } from '../contexts/AuthContext'
import { applyAppLocale } from '../i18n'
import { isAppLocale, resolvePreferredLocale, writeStoredLocale } from '../i18n/localeStorage'

/** After login, profile.preferred_locale wins over localStorage. */
export function LocaleSync() {
  const { profile, loading, permissionLoading } = useAuth()

  useEffect(() => {
    if (loading || permissionLoading) return
    const fromProfile = profile?.preferred_locale
    if (!isAppLocale(fromProfile) && fromProfile != null && fromProfile !== '') return
    const resolved = resolvePreferredLocale(fromProfile ?? null)
    writeStoredLocale(resolved)
    void applyAppLocale(resolved)
  }, [profile?.preferred_locale, profile?.id, loading, permissionLoading])

  return null
}
